/* SES Palma · portal · recepción asistida: lector de códigos, cámara y dictado (sobre el formulario de
   «Recepcionar» de ses-b2b-fulfil.js). Lógica pura en ses-b2b-rcv-tools.js.
   - Escanear: las pistolas USB/Bluetooth escriben el código muy rápido y terminan en Enter. En este modo
     las «recibidas» empiezan en 0 y cada lectura suma 1 a su línea (por EAN; si no, por SKU). Lo que no es
     del envío se avisa en rojo y se puede anotar como «Artículo equivocado».
   - Cámara: BarcodeDetector nativo si existe; si no, @zxing/library bajo demanda. EAN-13, EAN-8, Code 128.
   - Dictar: reconocimiento de voz del navegador; se enseña lo entendido y la línea antes de aplicarlo
     (se aplica solo a los 1,5 s si no se cancela, con deshacer). */
(function () {
  'use strict';
  const B = window.SESB2B;
  const T = window.SESRcvTools;
  if (!B || !T) return;
  const { esc, t } = B;

  B.extend({
    rc_tools:        { es: 'Ayudas para recepcionar', en: 'Receiving tools', fr: 'Outils de réception', it: 'Strumenti di ricezione' },
    rc_scan:         { es: 'Escanear', en: 'Scan', fr: 'Scanner', it: 'Scansiona' },
    rc_scan_on:      { es: 'Escaneando', en: 'Scanning', fr: 'Scan en cours', it: 'Scansione attiva' },
    rc_camera:       { es: 'Escanear con la cámara', en: 'Scan with the camera', fr: 'Scanner avec la caméra', it: 'Scansiona con la fotocamera' },
    rc_camera_stop:  { es: 'Cerrar la cámara', en: 'Close the camera', fr: 'Fermer la caméra', it: 'Chiudi la fotocamera' },
    rc_camera_err:   { es: 'No se ha podido abrir la cámara. Revisa el permiso del navegador.', en: 'The camera could not be opened. Check the browser permission.', fr: 'Impossible d\'ouvrir la caméra. Vérifiez l\'autorisation du navigateur.', it: 'Impossibile aprire la fotocamera. Controlla il permesso del browser.' },
    rc_camera_hint:  { es: 'Apunta al código de barras de la etiqueta.', en: 'Point at the barcode on the label.', fr: 'Visez le code-barres de l\'étiquette.', it: 'Inquadra il codice a barre dell\'etichetta.' },
    rc_voice:        { es: 'Dictar', en: 'Dictate', fr: 'Dicter', it: 'Detta' },
    rc_voice_listen: { es: 'Escuchando… di estilo, color, talla y cantidad', en: 'Listening… say style, colour, size and quantity', fr: 'Écoute… dites modèle, couleur, taille et quantité', it: 'In ascolto… di\' modello, colore, taglia e quantità' },
    rc_voice_privacy:{ es: 'El dictado usa el reconocimiento de voz de tu navegador.', en: 'Dictation uses your browser\'s speech recognition.', fr: 'La dictée utilise la reconnaissance vocale de votre navigateur.', it: 'La dettatura usa il riconoscimento vocale del tuo browser.' },
    rc_voice_heard:  { es: 'He entendido: «{text}»', en: 'I heard: "{text}"', fr: 'J\'ai compris : « {text} »', it: 'Ho capito: «{text}»' },
    rc_voice_apply:  { es: '{line}: {n} recibidas', en: '{line}: {n} received', fr: '{line} : {n} reçues', it: '{line}: {n} ricevute' },
    rc_v_add:        { es: '{line}: +{n} → {total}', en: '{line}: +{n} → {total}', fr: '{line} : +{n} → {total}', it: '{line}: +{n} → {total}' },
    rc_v_set:        { es: '{line}: = {n}', en: '{line}: = {n}', fr: '{line} : = {n}', it: '{line}: = {n}' },
    rc_mode:         { es: 'La cantidad dictada', en: 'The dictated quantity', fr: 'La quantité dictée', it: 'La quantità dettata' },
    rc_mode_add:     { es: 'Sumar', en: 'Add', fr: 'Ajouter', it: 'Sommare' },
    rc_mode_set:     { es: 'Sustituir', en: 'Replace', fr: 'Remplacer', it: 'Sostituire' },
    rc_mode_spoken:  { es: 'Por lo que has dicho: {mode}', en: 'From what you said: {mode}', fr: 'D\'après ce que vous avez dit : {mode}', it: 'Da quello che hai detto: {mode}' },
    rc_mode_hint:    { es: 'Puedes decir «más» para sumar o «son / en total» para sustituir.', en: 'Say "plus" to add or "total" to replace.', fr: 'Dites « en plus » pour ajouter ou « en total » pour remplacer.', it: 'Di\' «in più» per sommare o «in totale» per sostituire.' },
    rc_voice_auto:   { es: 'Se aplica en un momento…', en: 'Applying in a moment…', fr: 'Application dans un instant…', it: 'Applico tra un attimo…' },
    rc_voice_none:   { es: 'No encuentro esa línea en este envío. Repite con estilo, color, talla y cantidad.', en: 'I cannot find that line in this shipment. Please repeat with style, colour, size and quantity.', fr: 'Je ne trouve pas cette ligne dans cette expédition. Répétez avec modèle, couleur, taille et quantité.', it: 'Non trovo quella riga in questa spedizione. Ripeti con modello, colore, taglia e quantità.' },
    rc_voice_which:  { es: '¿Cuál de estas?', en: 'Which one?', fr: 'Laquelle ?', it: 'Quale?' },
    rc_voice_err:    { es: 'No te he oído bien. Prueba otra vez.', en: 'I did not catch that. Please try again.', fr: 'Je n\'ai pas bien entendu. Réessayez.', it: 'Non ho sentito bene. Riprova.' },
    rc_voice_denied: { es: 'El navegador no deja usar el micrófono. Revisa el permiso.', en: 'The browser does not allow the microphone. Check the permission.', fr: 'Le navigateur n\'autorise pas le micro. Vérifiez l\'autorisation.', it: 'Il browser non consente il microfono. Controlla il permesso.' },
    rc_apply:        { es: 'Aplicar', en: 'Apply', fr: 'Appliquer', it: 'Applica' },
    rc_cancel:       { es: 'Cancelar', en: 'Cancel', fr: 'Annuler', it: 'Annulla' },
    rc_undo:         { es: 'Deshacer', en: 'Undo', fr: 'Annuler', it: 'Annulla' },
    rc_undo_last:    { es: 'Deshacer la última lectura', en: 'Undo last scan', fr: 'Annuler le dernier scan', it: 'Annulla l\'ultima lettura' },
    rc_reset_sent:   { es: 'Volver a «recibidas = enviadas»', en: 'Back to "received = sent"', fr: 'Revenir à « reçues = envoyées »', it: 'Torna a «ricevute = inviate»' },
    rc_ready:        { es: 'Listo para escanear. Pasa la pistola por cada prenda.', en: 'Ready to scan. Scan each garment.', fr: 'Prêt à scanner. Scannez chaque article.', it: 'Pronto. Scansiona ogni capo.' },
    rc_ready_lost:   { es: 'Pulsa aquí para seguir escaneando', en: 'Tap here to keep scanning', fr: 'Touchez ici pour continuer à scanner', it: 'Tocca qui per continuare a scansionare' },
    rc_code_label:   { es: 'Código (lector o a mano)', en: 'Code (scanner or by hand)', fr: 'Code (lecteur ou à la main)', it: 'Codice (lettore o a mano)' },
    rc_count:        { es: '{n} lecturas', en: '{n} scans', fr: '{n} scans', it: '{n} letture' },
    rc_count1:       { es: '1 lectura', en: '1 scan', fr: '1 scan', it: '1 lettura' },
    rc_hit:          { es: '+1 {line} ({got} de {sent})', en: '+1 {line} ({got} of {sent})', fr: '+1 {line} ({got} sur {sent})', it: '+1 {line} ({got} di {sent})' },
    rc_over:         { es: '+1 {line}: ya hay más de las enviadas ({got} de {sent})', en: '+1 {line}: more than sent ({got} of {sent})', fr: '+1 {line} : plus que l\'envoyé ({got} sur {sent})', it: '+1 {line}: più delle inviate ({got} di {sent})' },
    rc_foreign:      { es: 'No pertenece a este envío: {code}', en: 'Not part of this shipment: {code}', fr: 'Ne fait pas partie de cette expédition : {code}', it: 'Non fa parte di questa spedizione: {code}' },
    rc_foreign_add:  { es: 'Anotar como «Artículo equivocado»', en: 'Log as "Wrong item"', fr: 'Noter comme « Mauvais article »', it: 'Registra come «Articolo sbagliato»' },
    rc_foreign_h:    { es: 'Recibido y no es de este envío', en: 'Received but not in this shipment', fr: 'Reçu mais hors de cette expédition', it: 'Ricevuto ma non di questa spedizione' },
    rc_foreign_note: { es: 'No pertenece al envío (código {code})', en: 'Not part of the shipment (code {code})', fr: 'Hors expédition (code {code})', it: 'Fuori spedizione (codice {code})' },
    rc_remove:       { es: 'Quitar', en: 'Remove', fr: 'Retirer', it: 'Rimuovi' },
    rc_undone:       { es: 'Deshecho', en: 'Undone', fr: 'Annulé', it: 'Annullato' },
  });

  const SR = window.SpeechRecognition || window.webkitSpeechRecognition || null;
  const ZXING = 'https://cdn.jsdelivr.net/npm/@zxing/library@0.21.3/umd/index.min.js';
  const MIC = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/></svg>';
  const SCAN = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 7V5a1 1 0 0 1 1-1h2M17 4h2a1 1 0 0 1 1 1v2M20 17v2a1 1 0 0 1-1 1h-2M7 20H5a1 1 0 0 1-1-1v-2M7 8v8M10 8v8M13 8v8M16 8v8"/></svg>';
  const CAM = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 8h3l2-2h6l2 2h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg>';

  /* ---------- sonido ---------- */
  let audio = null;
  function beep(kind) {
    try {
      audio = audio || new (window.AudioContext || window.webkitAudioContext)();
      const o = audio.createOscillator(), g = audio.createGain();
      const f = { ok: 1320, warn: 660, err: 220 }[kind] || 880;
      const d = kind === 'err' ? 0.28 : 0.09;
      o.frequency.value = f; o.type = kind === 'err' ? 'square' : 'sine';
      g.gain.setValueAtTime(0.0001, audio.currentTime);
      g.gain.exponentialRampToValueAtTime(0.12, audio.currentTime + 0.01);
      g.gain.exponentialRampToValueAtTime(0.0001, audio.currentTime + d);
      o.connect(g); g.connect(audio.destination);
      o.start(); o.stop(audio.currentTime + d + 0.02);
      if (kind === 'warn') setTimeout(() => beep('ok'), 120);
    } catch (_) { /* sin audio: solo aviso visual */ }
  }

  function script(src) {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`) && window.ZXing) { resolve(); return; }
      const s = document.createElement('script');
      s.src = src; s.async = true; s.crossOrigin = 'anonymous';
      s.onload = resolve; s.onerror = () => reject(new Error('lib'));
      document.head.appendChild(s);
    });
  }

  // form: el formulario; opts: { rows:[{sku,name,color,size,units_sent}], eans: Promise<Map sku→ean>, root, ... }
  // Por defecto es la recepción de un envío; el reporte de ventas (ses-b2b-sellout.js) pasa sus selectores y
  // textos: units_sent es entonces el stock en tienda y la cantidad son las vendidas.
  // Devuelve { foreignLines() → [{sku, received, incident, note}], destroy() }
  function attach(form, opts) {
    const rows = opts.rows;
    const o = Object.assign({
      lineSel: '.ff-rcv-line', qtySel: '[data-got]', anchorSel: '.ff-rcv-date', startZero: true,
      text: { hit: 'rc_hit', over: 'rc_over', reset: 'rc_reset_sent', foreignAdd: 'rc_foreign_add', foreignHead: 'rc_foreign_h', foreignTag: 'ff_inc_WRONG_ITEM' },
    }, opts);
    o.text = Object.assign({ hit: 'rc_hit', over: 'rc_over', reset: 'rc_reset_sent', foreignAdd: 'rc_foreign_add', foreignHead: 'rc_foreign_h', foreignTag: 'ff_inc_WRONG_ITEM' }, opts.text || {});
    const lineEl = new Map([...form.querySelectorAll(o.lineSel)].map((li) => [li.dataset.sku, li]));
    const bySku = new Map(rows.map((r) => [r.sku, r]));
    const codeToSku = new Map();          // EAN o SKU (mayúsculas) → SKU del envío
    const eanToAnySku = new Map();        // EAN de la temporada → SKU (para lo que no es del envío)
    rows.forEach((r) => codeToSku.set(String(r.sku).toUpperCase(), r.sku));
    Promise.resolve(opts.eans).then((m) => {
      (m || new Map()).forEach((ean, sku) => {
        eanToAnySku.set(String(ean), sku);
        if (bySku.has(sku)) codeToSku.set(String(ean), sku);
      });
    }).catch(() => {});
    const label = (r) => `${r.name} · ${r.color} · ${r.size}`;

    const uid = 'rcu' + Math.random().toString(36).slice(2, 7);
    const box = document.createElement('div');
    box.className = 'ff-tools-box';
    box.innerHTML = `
      <div class="ff-tools" role="group" aria-label="${esc(t('rc_tools'))}">
        <button type="button" class="b2b-btn b2b-btn--secondary" data-tool="scan" aria-pressed="false" aria-controls="${uid}s">${SCAN}<span>${esc(t('rc_scan'))}</span></button>
        <button type="button" class="b2b-btn b2b-btn--secondary" data-tool="camera" aria-pressed="false" hidden>${CAM}<span>${esc(t('rc_camera'))}</span></button>
        <button type="button" class="b2b-btn b2b-btn--secondary" data-tool="voice" hidden>${MIC}<span>${esc(t('rc_voice'))}</span></button>
      </div>
      <p class="bp-muted bp-small ff-voice-privacy" hidden>${esc(t('rc_voice_privacy'))}</p>
      <section class="ff-scan" id="${uid}s" hidden aria-label="${esc(t('rc_scan_on'))}">
        <div class="ff-scan-row">
          <label class="ff-scan-field"><span class="b2b-label">${esc(t('rc_code_label'))}</span>
            <input class="b2b-input ff-scan-input" type="text" inputmode="numeric" autocomplete="off" autocapitalize="off" spellcheck="false" enterkeyhint="done"></label>
          <p class="ff-scan-count u-tnum" role="status" aria-live="polite">${esc(t('rc_count', { n: 0 }))}</p>
        </div>
        <button type="button" class="ff-scan-ready" data-refocus>${esc(t('rc_ready'))}</button>
        <div class="ff-camera" hidden><video class="ff-video" playsinline muted aria-label="${esc(t('rc_camera'))}"></video>
          <p class="bp-muted bp-small">${esc(t('rc_camera_hint'))}</p></div>
        <p class="ff-scan-msg" role="alert" aria-live="assertive" hidden></p>
        <div class="ff-scan-actions">
          <button type="button" class="b2b-btn b2b-btn--ghost" data-undo disabled>${esc(t('rc_undo_last'))}</button>
          <button type="button" class="b2b-btn b2b-btn--ghost" data-reset>${esc(t(o.text.reset))}</button>
        </div>
        <div class="ff-foreign" hidden><p class="b2b-label">${esc(t(o.text.foreignHead))}</p><ul class="ff-foreign-list" role="list"></ul></div>
      </section>
      <section class="ff-voice" hidden>
        <div class="ff-voice-mode"><span class="b2b-label" id="${uid}vm">${esc(t('rc_mode'))}</span>
          <div class="ff-seg" role="group" aria-labelledby="${uid}vm">
            <button type="button" class="ff-seg-btn" data-vmode="add">${esc(t('rc_mode_add'))}</button>
            <button type="button" class="ff-seg-btn" data-vmode="replace">${esc(t('rc_mode_set'))}</button>
          </div>
          <p class="bp-muted bp-small ff-voice-hint">${esc(t('rc_mode_hint'))}</p></div>
        <div class="ff-voice-body" aria-live="polite"></div>
      </section>`;
    form.querySelector(o.anchorSel).after(box);

    const $ = (s) => box.querySelector(s);
    const scanBtn = $('[data-tool="scan"]'), camBtn = $('[data-tool="camera"]'), voiceBtn = $('[data-tool="voice"]');
    const panel = $('.ff-scan'), input = $('.ff-scan-input'), msg = $('.ff-scan-msg'), count = $('.ff-scan-count');
    const ready = $('.ff-scan-ready'), undoBtn = $('[data-undo]'), foreignBox = $('.ff-foreign'), foreignList = $('.ff-foreign-list');
    const voiceBox = $('.ff-voice');
    const vBody = $('.ff-voice-body');
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) camBtn.hidden = false;
    if (SR) { voiceBtn.hidden = false; $('.ff-voice-privacy').hidden = false; }

    let scanning = false;
    let scans = 0;
    const history = [];               // {type:'line', sku, prev} | {type:'foreign', code}
    const foreign = new Map();        // code → {code, sku, n}
    const burst = new T.ScanBurst();
    let burstStart = null;            // {el, value, selectedIndex} al empezar una ráfaga fuera del campo del lector

    const changed = () => form.dispatchEvent(new Event('input', { bubbles: true }));
    const gotInput = (sku) => lineEl.get(sku).querySelector(o.qtySel);
    function flash(sku, kind) {
      const li = lineEl.get(sku);
      li.classList.remove('is-flash', 'is-flash-warn');
      void li.offsetWidth;
      li.classList.add(kind === 'warn' ? 'is-flash-warn' : 'is-flash');
      clearTimeout(li._flashT);
      li._flashT = setTimeout(() => li.classList.remove('is-flash', 'is-flash-warn'), 1300);
      li.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    function say(text, kind, action) {
      msg.hidden = false;
      msg.className = 'ff-scan-msg ff-scan-msg--' + (kind || 'ok');
      msg.innerHTML = `<span>${esc(text)}</span>${action || ''}`;
    }
    function paintCount() { count.textContent = scans === 1 ? t('rc_count1') : t('rc_count', { n: B.fmtInt(scans) }); undoBtn.disabled = !history.length; }
    function paintForeign() {
      foreignBox.hidden = !foreign.size;
      foreignList.innerHTML = [...foreign.values()].map((f) => {
        return `<li class="ff-foreign-item"><span><strong class="ff-code">${esc(f.code)}</strong>${f.sku && f.sku !== f.code ? ` <span class="bp-muted">${esc(f.sku)}</span>` : ''} · ${B.fmtInt(f.n)} · ${esc(t(o.text.foreignTag))}</span>
          <button type="button" class="b2b-btn b2b-btn--ghost" data-foreign-del="${esc(f.code)}">${esc(t('rc_remove'))}</button></li>`;
      }).join('');
    }

    function setMode(on) {
      scanning = on;
      scanBtn.setAttribute('aria-pressed', String(on));
      scanBtn.lastElementChild.textContent = t(on ? 'rc_scan_on' : 'rc_scan');
      panel.hidden = !on;
      if (on) {
        if (o.startZero) lineEl.forEach((li, sku) => { gotInput(sku).value = '0'; });
        scans = 0; history.length = 0; paintCount(); msg.hidden = true;
        changed();
        focusInput();
      } else {
        stopCamera();
      }
    }
    function focusInput() { if (scanning) input.focus({ preventScroll: true }); paintReady(); }
    function paintReady() { const has = document.activeElement === input; ready.textContent = t(has ? 'rc_ready' : 'rc_ready_lost'); ready.classList.toggle('is-lost', !has); }

    function processCode(raw) {
      const code = String(raw || '').trim();
      if (!code) return;
      const sku = codeToSku.get(code) || codeToSku.get(code.toUpperCase());
      if (sku) {
        const el = gotInput(sku);
        const prev = Number(el.value) || 0;
        el.value = String(prev + 1);
        history.push({ type: 'line', sku, prev });
        scans++;
        const r = bySku.get(sku);
        const over = prev + 1 > Number(r.units_sent);
        lineEl.get(sku).classList.toggle('is-over', over);
        beep(over ? 'warn' : 'ok');
        flash(sku, over ? 'warn' : 'ok');
        say(t(over ? o.text.over : o.text.hit, { line: label(r), got: prev + 1, sent: r.units_sent }), over ? 'warn' : 'ok');
        changed();
      } else {
        beep('err');
        say(t('rc_foreign', { code }), 'err', `<button type="button" class="b2b-btn b2b-btn--secondary" data-foreign-add="${esc(code)}">${esc(t(o.text.foreignAdd))}</button>`);
      }
      paintCount();
    }
    function addForeign(code) {
      const f = foreign.get(code) || { code, sku: eanToAnySku.get(code) || code, n: 0 };
      f.n++;
      foreign.set(code, f);
      history.push({ type: 'foreign', code });
      scans++;
      paintForeign(); paintCount(); changed();
      msg.hidden = true;
      focusInput();
    }
    function undo() {
      const h = history.pop();
      if (!h) return;
      if (h.type === 'line') {
        gotInput(h.sku).value = String(h.prev);
        lineEl.get(h.sku).classList.toggle('is-over', h.prev > Number(bySku.get(h.sku).units_sent));
        flash(h.sku, 'ok');
      } else {
        const f = foreign.get(h.code);
        if (f && --f.n <= 0) foreign.delete(h.code);
        paintForeign();
      }
      scans = Math.max(0, scans - 1);
      say(t('rc_undone'), 'ok');
      paintCount(); changed(); focusInput();
    }

    // Teclado: la pistola escribe muy rápido y acaba en Enter/Tab. Si la ráfaga cae en otro campo (una nota),
    // se devuelve ese campo a como estaba y se procesa el código. Enter nunca envía el formulario en este modo.
    function onKey(e) {
      if (!scanning || e.isComposing || e.ctrlKey || e.metaKey || e.altKey) return;
      const el = e.target;
      const isInput = el === input;
      if (e.key === 'Enter' || e.key === 'Tab') {
        const res = burst.feed(e.key, e.timeStamp);
        const restore = burstStart;
        burstStart = null;
        if (res && res.type === 'scan') {
          e.preventDefault(); e.stopPropagation();
          if (!isInput && restore && restore.el && 'value' in restore.el) {
            restore.el.value = restore.value;
            if (restore.selectedIndex != null) restore.el.selectedIndex = restore.selectedIndex;
            restore.el.dispatchEvent(new Event('input', { bubbles: true }));
          }
          processCode(res.code);
          input.value = '';
          if (!isInput && (document.activeElement === document.body || !form.contains(document.activeElement))) focusInput();
          return;
        }
        if (isInput && e.key === 'Enter') {
          e.preventDefault();
          processCode(input.value);
          input.value = '';
          return;
        }
        if (e.key === 'Enter' && el.tagName !== 'BUTTON' && el.tagName !== 'TEXTAREA') e.preventDefault();
        return;
      }
      if (e.key.length === 1) {
        if ((!burst.buf || e.timeStamp - burst.last > burst.resetGap) && !isInput) burstStart = { el, value: el.value, selectedIndex: el.tagName === 'SELECT' ? el.selectedIndex : null };
        burst.feed(e.key, e.timeStamp);
        // en un desplegable, la búsqueda por letra cambiaría la opción: se bloquea mientras parece lector
        if (!isInput && el.tagName === 'SELECT' && burst.looksLikeScan()) e.preventDefault();
      }
    }
    form.addEventListener('keydown', onKey, true);
    input.addEventListener('focus', paintReady);
    input.addEventListener('blur', () => setTimeout(() => {
      paintReady();
      // no se roba el foco de otros campos; solo se recupera si se ha ido «a ninguna parte»
      if (scanning && (document.activeElement === document.body || document.activeElement === null)) focusInput();
    }, 0));

    box.addEventListener('click', (e) => {
      const add = e.target.closest('[data-foreign-add]');
      if (add) { addForeign(add.dataset.foreignAdd); return; }
      const del = e.target.closest('[data-foreign-del]');
      if (del) { foreign.delete(del.dataset.foreignDel); paintForeign(); changed(); return; }
    });
    scanBtn.addEventListener('click', () => { beepUnlock(); setMode(!scanning); });
    ready.addEventListener('click', focusInput);
    undoBtn.addEventListener('click', undo);
    $('[data-reset]').addEventListener('click', () => {
      setMode(false);
      lineEl.forEach((li, sku) => { gotInput(sku).value = String(o.resetValue ? o.resetValue(bySku.get(sku)) : bySku.get(sku).units_sent); li.classList.remove('is-over'); });
      history.length = 0; scans = 0; paintCount();
      changed();
      scanBtn.focus();
    });
    function beepUnlock() { try { audio = audio || new (window.AudioContext || window.webkitAudioContext)(); if (audio.state === 'suspended') audio.resume(); } catch (_) { /* sin audio */ } }

    /* ---------- cámara ---------- */
    let stream = null, loop = null, zx = null, lastCode = '', lastAt = 0;
    const camBox = $('.ff-camera'), video = $('.ff-video');
    function onCamCode(code) {
      const now = Date.now();
      if (code === lastCode && now - lastAt < 1500) return;   // la misma etiqueta sigue delante
      lastCode = code; lastAt = now;
      processCode(code);
    }
    async function startCamera() {
      if (!scanning) setMode(true);
      camBtn.setAttribute('aria-pressed', 'true');
      camBtn.lastElementChild.textContent = t('rc_camera_stop');
      camBox.hidden = false;
      try {
        const formats = ['ean_13', 'ean_8', 'code_128'];
        let native = false;
        if ('BarcodeDetector' in window) {
          try { const sup = await window.BarcodeDetector.getSupportedFormats(); native = formats.some((f) => sup.includes(f)); } catch (_) { native = false; }
        }
        if (native) {
          stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' } }, audio: false });
          video.srcObject = stream;
          await video.play();
          const det = new window.BarcodeDetector({ formats });
          const tick = async () => {
            if (!stream) return;
            try { const found = await det.detect(video); if (found && found[0]) onCamCode(found[0].rawValue); } catch (_) { /* fotograma sin código */ }
            loop = setTimeout(tick, 200);
          };
          tick();
        } else {
          await script(ZXING);
          const Z = window.ZXing;
          const hints = new Map();
          hints.set(Z.DecodeHintType.POSSIBLE_FORMATS, [Z.BarcodeFormat.EAN_13, Z.BarcodeFormat.EAN_8, Z.BarcodeFormat.CODE_128]);
          zx = new Z.BrowserMultiFormatReader(hints, 250);
          await zx.decodeFromConstraints({ video: { facingMode: { ideal: 'environment' } } }, video, (res) => { if (res) onCamCode(res.getText()); });
        }
      } catch (e) {
        console.warn('cámara', e);
        stopCamera();
        beep('err');
        say(t('rc_camera_err'), 'err');
      }
    }
    function stopCamera() {
      clearTimeout(loop); loop = null;
      if (zx) { try { zx.reset(); } catch (_) { /* ya parado */ } zx = null; }
      if (stream) { stream.getTracks().forEach((tr) => tr.stop()); stream = null; }
      video.srcObject = null;
      camBox.hidden = true;
      camBtn.setAttribute('aria-pressed', 'false');
      camBtn.lastElementChild.textContent = t('rc_camera');
    }
    camBtn.addEventListener('click', () => { beepUnlock(); if (stream || zx) stopCamera(); else startCamera(); });

    /* ---------- voz ---------- */
    let rec = null, autoTimer = null;
    const lastVoice = [];   // deshacer: {sku, prev}
    // Sumar (por defecto) o sustituir; se recuerda en este navegador. Lo dicho en la frase manda sobre esto.
    const MODE_KEY = 'ses_rcv_voice_mode';
    let vMode = 'add';
    try { if (localStorage.getItem(MODE_KEY) === 'replace') vMode = 'replace'; } catch (_) { /* sin almacenamiento */ }
    function paintMode() { voiceBox.querySelectorAll('[data-vmode]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.vmode === vMode))); }
    paintMode();
    voiceBox.querySelectorAll('[data-vmode]').forEach((b) => b.addEventListener('click', () => {
      vMode = b.dataset.vmode;
      try { localStorage.setItem(MODE_KEY, vMode); } catch (_) { /* sin almacenamiento */ }
      paintMode();
    }));
    const current = (sku) => Number(gotInput(sku).value) || 0;
    const effect = (r, qty, mode) => (mode === 'add'
      ? t('rc_v_add', { line: label(r), n: qty, total: current(r.sku) + qty })
      : t('rc_v_set', { line: label(r), n: qty }));
    function voiceApply(r, qty, mode) {
      clearTimeout(autoTimer);
      const el = gotInput(r.sku);
      const prev = Number(el.value) || 0;
      const next = mode === 'add' ? prev + qty : qty;
      el.value = String(next);
      lastVoice.push({ sku: r.sku, prev });
      lineEl.get(r.sku).classList.toggle('is-over', next > Number(r.units_sent));
      flash(r.sku, next > Number(r.units_sent) ? 'warn' : 'ok');
      beep('ok');
      changed();
      const shown = mode === 'add' ? t('rc_v_add', { line: label(r), n: qty, total: next }) : t('rc_v_set', { line: label(r), n: qty });
      vBody.innerHTML = `<p class="ff-voice-done"><strong>${esc(shown)}</strong></p>
        <div class="ff-voice-actions"><button type="button" class="b2b-btn b2b-btn--ghost" data-v="undo">${esc(t('rc_undo'))}</button>
        <button type="button" class="b2b-btn b2b-btn--secondary" data-v="again">${MIC}<span>${esc(t('rc_voice'))}</span></button></div>`;
    }
    function voiceShow(text) {
      const res = T.parseVoice(text, rows);
      voiceBox.hidden = false;
      const heard = `<p class="ff-voice-heard">${esc(t('rc_voice_heard', { text }))}</p>`;
      const mode = res.mode || vMode;
      const spoken = res.mode ? `<p class="bp-muted bp-small">${esc(t('rc_mode_spoken', { mode: t(res.mode === 'add' ? 'rc_mode_add' : 'rc_mode_set') }))}</p>` : '';
      if (res.ok) {
        vBody.innerHTML = `${heard}<p class="ff-voice-match"><strong>${esc(effect(res.line, res.qty, mode))}</strong></p>${spoken}
          <p class="bp-muted bp-small ff-voice-auto">${esc(t('rc_voice_auto'))}</p>
          <div class="ff-voice-actions"><button type="button" class="b2b-btn b2b-btn--primary" data-v="apply">${esc(t('rc_apply'))}</button>
          <button type="button" class="b2b-btn b2b-btn--ghost" data-v="cancel">${esc(t('rc_cancel'))}</button></div>`;
        voiceBox._pending = { res, mode };
        autoTimer = setTimeout(() => voiceApply(res.line, res.qty, mode), 1500);
      } else if (res.candidates.length > 1 && res.candidates.length <= 6) {
        const q = res.understood.qty == null ? 1 : res.understood.qty;
        vBody.innerHTML = `${heard}<p>${esc(t('rc_voice_which'))}</p><div class="ff-voice-actions">${res.candidates.map((c) =>
          `<button type="button" class="b2b-btn b2b-btn--secondary" data-v="pick" data-sku="${esc(c.sku)}" data-qty="${q}" data-mode="${mode}">${esc(effect(c, q, mode))}</button>`).join('')}
          <button type="button" class="b2b-btn b2b-btn--ghost" data-v="again">${MIC}<span>${esc(t('rc_voice'))}</span></button></div>`;
      } else {
        beep('err');
        vBody.innerHTML = `${heard}<p class="ff-voice-none">${esc(t('rc_voice_none'))}</p>
          <div class="ff-voice-actions"><button type="button" class="b2b-btn b2b-btn--secondary" data-v="again">${MIC}<span>${esc(t('rc_voice'))}</span></button></div>`;
      }
      const first = voiceBox.querySelector('button');
      if (first) first.focus({ preventScroll: true });
    }
    function listen() {
      if (!SR) return;
      beepUnlock();
      clearTimeout(autoTimer);
      try { if (rec) rec.abort(); } catch (_) { /* nada que parar */ }
      rec = new SR();
      rec.lang = T.SPEECH_LANG[B.getLang()] || 'es-ES';
      rec.interimResults = true;
      rec.maxAlternatives = 1;
      rec.continuous = false;
      voiceBox.hidden = false;
      vBody.innerHTML = `<p class="ff-voice-listen">${MIC}<span>${esc(t('rc_voice_listen'))}</span></p><p class="bp-muted ff-voice-live"></p>`;
      voiceBtn.setAttribute('aria-pressed', 'true');
      let final = '';
      rec.onresult = (ev) => {
        let interim = '';
        for (let i = ev.resultIndex; i < ev.results.length; i++) {
          if (ev.results[i].isFinal) final += ev.results[i][0].transcript;
          else interim += ev.results[i][0].transcript;
        }
        const live = voiceBox.querySelector('.ff-voice-live');
        if (live) live.textContent = final || interim;
      };
      rec.onerror = (ev) => {
        voiceBtn.setAttribute('aria-pressed', 'false');
        if (ev.error === 'aborted') return;
        vBody.innerHTML = `<p class="ff-voice-none">${esc(t(ev.error === 'not-allowed' || ev.error === 'service-not-allowed' ? 'rc_voice_denied' : 'rc_voice_err'))}</p>`;
      };
      rec.onend = () => {
        voiceBtn.setAttribute('aria-pressed', 'false');
        if (final.trim()) voiceShow(final.trim());
        else if (voiceBox.querySelector('.ff-voice-listen')) vBody.innerHTML = `<p class="ff-voice-none">${esc(t('rc_voice_err'))}</p>`;
      };
      try { rec.start(); } catch (_) { vBody.innerHTML = `<p class="ff-voice-none">${esc(t('rc_voice_err'))}</p>`; }
    }
    voiceBtn.addEventListener('click', listen);
    voiceBox.addEventListener('click', (e) => {
      const b = e.target.closest('[data-v]');
      if (!b) return;
      const act = b.dataset.v;
      if (act === 'apply' && voiceBox._pending) voiceApply(voiceBox._pending.res.line, voiceBox._pending.res.qty, voiceBox._pending.mode);
      else if (act === 'cancel') { clearTimeout(autoTimer); voiceBox._pending = null; vBody.innerHTML = ''; voiceBox.hidden = true; voiceBtn.focus(); }
      else if (act === 'pick') voiceApply(bySku.get(b.dataset.sku), Number(b.dataset.qty), b.dataset.mode);
      else if (act === 'again') listen();
      else if (act === 'undo') {
        const u = lastVoice.pop();
        if (u) { gotInput(u.sku).value = String(u.prev); lineEl.get(u.sku).classList.toggle('is-over', u.prev > Number(bySku.get(u.sku).units_sent)); flash(u.sku, 'ok'); changed(); }
        vBody.innerHTML = `<p>${esc(t('rc_undone'))}</p>`;
      }
    });

    const api = {
      // lo escaneado que no está en la lista: [{code, sku, n}]
      foreignItems: () => [...foreign.values()].filter((f) => !bySku.has(f.sku)).map((f) => Object.assign({}, f)),
      // lo que no es del envío, agrupado por SKU (dos códigos pueden ser la misma prenda)
      foreignLines: () => {
        const agg = new Map();
        foreign.forEach((f) => {
          if (bySku.has(f.sku)) return;
          const a = agg.get(f.sku) || { sku: f.sku, received: 0, incident: 'WRONG_ITEM', codes: [] };
          a.received += f.n; a.codes.push(f.code);
          agg.set(f.sku, a);
        });
        return [...agg.values()].map((a) => ({ sku: a.sku, received: a.received, incident: a.incident, note: t('rc_foreign_note', { code: a.codes.join(', ') }) }));
      },
      destroy: () => {
        stopCamera();
        clearTimeout(autoTimer);
        try { if (rec) rec.abort(); } catch (_) { /* nada */ }
        form.removeEventListener('keydown', onKey, true);
      },
      // para pruebas (scripts y mock): dictado sin micrófono
      _voice: voiceShow,
    };
    B.rcvAssist.last = api;
    return api;
  }

  B.rcvAssist = { attach, supportsVoice: !!SR };
})();
